
import { defineComponent, PropType } from 'vue'
import { CustomerMVPModel } from '@/types/Customer'

export default defineComponent({
  name: 'PlatinumMemberBox',
  props: {
    customerMVPInfo: {
      type: Object as PropType<CustomerMVPModel>,
      default: () => { return {} }
    }
  },
  computed: {
    GetShowType (): number {
      let showType = 0
      const mvpInfo = this.customerMVPInfo
      if (mvpInfo == null) return 0
      if (mvpInfo.isLogined && mvpInfo.isMVP) {
        showType = 3
      } else {
        if (mvpInfo.isGetFreeTrailMVP) { showType = 2 } else { showType = 1 }
      }
      return showType
    }
  }
})
